/** tempexp_14728-full-file */
import React, { FC } from 'react';

import { ArchiveItemProps } from '../../DataListItemRow.types';
import { Download } from '../Download/Download';
import { ItemName } from '../ItemName/ItemName';
import { Pic } from '../Pic/Pic';
import { Size } from '../Size/Size';
import { TableColumn } from '../TableColumn/TableColumn';

interface ArchiveProps extends ArchiveItemProps {}

export const Archive: FC<ArchiveProps> = (props) => {
    return (
        <>
            <TableColumn>
                <Pic isFolder={props.isFolder} kind={props.kind} isVirus={false} ext={props.ext || ''} />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName name={props.nameWithoutExt || props.name} ext={props.ext || ''} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                {!props.isFolder && !props.isEncrypted && (
                    <Download onClick={props.onDownload} ext={props.ext} size={props.size} id={props.id} storage={props.storage} />
                )}
            </TableColumn>
        </>
    );
};
